module.exports = __webpack_public_path__ + "img/30600.cdbc7599.jpg";